export const PayoutFrequencyOptions = {
	PAY_PERIOD: { value: "PAY_PERIOD", label: "Pay Period" },
	COMMISSION_CYCLE: { value: "COMMISSION_CYCLE", label: "Commission Cycle" },
};
